// extracted by mini-css-extract-plugin
export var addToCartButton = "_tv-b";
export var arrowButtonContainer = "_tv-9";
export var arrowButtonIcon = "_tv-a";
export var carouselArrowButton = "_tv-6";
export var carouselElementContainer = "_tv-1";
export var left = "_tv-7";
export var productDisplayCarouselContainer = "_tv-0";
export var productTileContainer = "_tv-2";
export var productTileImage = "_tv-4";
export var productTileImageContainer = "_tv-3";
export var productTileTitle = "_tv-5";
export var right = "_tv-8";
export var sliderOverflow = "_tv-c";